module.exports = __webpack_public_path__ + "img/app-store-available.98d46648.png";